import { ForwardedRef, forwardRef, ReactNode } from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';

import { ISvgIconProps } from './withSvgIcon';

export const withSvgIconSimple = (
  element: ReactNode,
  extraProps?: SvgIconProps,
) =>
  forwardRef(
    (
      { htmlColor, ...props }: ISvgIconProps,
      ref: ForwardedRef<SVGSVGElement>,
    ) => {
      const theme = useTheme();

      return (
        <SvgIcon
          ref={ref}
          htmlColor={htmlColor || theme.palette.grey['700']}
          {...(extraProps || {})}
          {...props}
        >
          {element}
        </SvgIcon>
      );
    },
  );
